import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { ICityMastDropdown, IStateMastDropdown, IUsersDropdown, IVisaDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { EmptyBenchConsultant } from "./EmptyBenchConsultant";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { JVDropdown } from "../../shared/JVDropdown";
import { IModel } from "./BenchConsultant";
import { JVInputMask } from "../../shared/JVInputMask";
import { ILogin } from "../../models/Login";


const schema = yup.object({
    consultant_Name: yup.string().required("Consultant Name is required*").min(3),
    phone: yup.string().required("Phone No. is required*"),
    job_Titles: yup.string().required("Job Title is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    visa: yup.number().min(1, "Visa is required").required("Visa is required"),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*"),
        state_Name: yup.string()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*"),
        city_Name: yup.string()
    }),
    rate: yup.number().required("Rate is required*"),
    f2F: yup.string().nullable(),
    marketing_Status: yup.string().nullable(),
    marketing_Priority: yup.string().nullable(),
    recruiter_ID: yup.number().min(1, "Recruiter is required").required("Recruiter is required"),
    consultant_Type: yup.string().nullable(),
    comment: yup.string().nullable(),
    sub_Vendor_Company: yup.string().required("Sub vendor company is required"),
    contact_Person_Name: yup.string().nullable()
});

interface Iprops {
    singleData: IBenchConsultant,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    modal: IModel
}

export const Form = (props: Iprops) => {
    const [visa, setVisa] = useState<Array<IVisaDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [state, setState] = useState<Array<IStateMastDropdown>>();
    const [city, setCity] = useState<Array<ICityMastDropdown>>();
    const [loading, setLoading] = useState(false);
    const [resume, setResume] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IBenchConsultant>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    const loadVisa = async () => {
        const response = await Fetch("Dropdown/visa", "GET", null, null, null);
        if (response) {
            const data: Array<IVisaDropdown> = await response.json();
            setVisa(data);
        }
    }

    const loadRecruiter = async () => {
        const response = await Fetch("Dropdown/UsersByRole", "GET", null, `role_id=${3}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setRecruiters(data);
        }
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data = await response.json();
            setState(data);
        }
    }


    const loadCity = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data = await response.json();
                setCity(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }

    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCity(event.query);
    }

    useEffect(() => {
        loadVisa();
        loadRecruiter();
        loadStates(null);
    }, []);

    const saveToDB = async (body: IBenchConsultant) => {
        setLoading(true);
        const method = props.singleData.consultant_ID ? "PUT" : "POST";
        if ((method === "POST" && resume) || method === "PUT") {
            const message = props.singleData.consultant_ID ? "Updated Successfully" : "Added Successfully";

            body.state_ID = body.state?.state_ID;
            body.city_ID = body.city?.city_ID;
            delete body.city;
            delete body.state;

            const response = await Fetch("Consultant_Bench", method, body, null, props.toast);

            if (response) {
                onHide();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
        }
        else props.toast.current.show({ severity: 'error', detail: "Please Upload the Consultant Resume First.", life: 3000 });

        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyBenchConsultant);
        setResume(false);
    }

    function OnSubmit(data: IBenchConsultant) {
        saveToDB(data);
    }

    const resumeUploade = (event: FileUploadHandlerParam) => {
        // console.log(event.files[0].type);
        if (event.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            if (event.files[0].size > 2048000) {
                // console.log(event.files[0].size);
                props.toast.current.show({ severity: 'error', content: "DOCX File should be less than 2 MB." });
                event.options.clear();
            } else {
                uploadeResume(event.files[0]);
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A DOCX File." });
            event.options.clear();
        }
    }

    const uploadeResume = async (resume: File) => {
        setLoading(true);
        let formData = new FormData();
        formData.append("resume", resume);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Consultant_Mast/resume`, params);
        if (response) {
            setResume(true);
            props.toast.current.show({ severity: 'success', content: "Resume Uploaded Successfully." });
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open && _roles.includes(3) && !_roles.includes(24)) {
            setValue('recruiter_ID', loginObj.id);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Update Bench Consultant" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(OnSubmit)} className="p-fluid formgrid grid">

                <JVInput column={3} required label="Consultant Name" control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
                <JVInputMask column={3} mask="(999) 999-9999" required label="Phone number" control={control} name="phone" error={errors.phone?.message} />
                <JVInput column={3} required label="Job Title" control={control} name="job_Titles" error={errors.job_Titles?.message} />
                <JVInput column={3} required label="Email" control={control} name="email" error={errors.email?.message} />
                <JVDropdown column={3} required label="Visa " control={control} name="visa" options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="Select Visa" error={errors.visa?.message} />

                <JVDropdownInput column={3} required completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={state} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput column={3} required completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={city} optionLabel="city_Name" placeholder="Search City" />
                <JVInput column={3} required label="Rate" control={control} name="rate" error={errors.rate?.message} />

                <JVRadioBtn column={3} label="F2F Interview" data={["Yes", "No"]} control={control} name="f2F" error={errors.f2F?.message} />
                <JVDropdown column={3} label="Marketing Status " control={control} name="marketing_Status" options={[{ status: "Hold" }, { status: "Stop" }, { status: "Marketing Start" }]} optionLabel="status" optionValue="status" placeholder="Select Status" />

                <JVDropdown column={3} label="Priority" control={control} name="marketing_Priority" options={[{ priority: "High" }, { priority: "Medium" }, { priority: "Low" }]} optionLabel="priority" optionValue="priority" placeholder="Select Priority" error={errors.marketing_Priority?.message} />
                <JVDropdown column={3} required label="Recruiter " control={control} name="recruiter_ID" disabled={!_roles.includes(24)} options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" error={errors.recruiter_ID?.message} />
                <JVRadioBtn column={3} label="Consultant Type" data={["C2C", "W2"]} control={control} name="consultant_Type" error={errors.consultant_Type?.message} />

                <div className="field col-12 md:col-4">
                    <label htmlFor="">Resume Attach</label>
                    <FileUpload chooseLabel="Choose Resume" mode="basic" name="resume" accept=".docx" maxFileSize={1000000} customUpload uploadHandler={resumeUploade} />
                </div>
                <JVInput column={3} label="Comment" control={control} name="comment" error={errors.comment?.message} />
                <JVInput column={3} required label="Sub Vendor Company" control={control} name="sub_Vendor_Company" error={errors.sub_Vendor_Company?.message} />
                <JVInput column={3} label="Contact Person" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <div className="field col-12 md:col-4">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} label="SAVE" type="submit"></Button>
                </div>
            </form>
        </Dialog>
    );
}
